import { css } from "@emotion/core";
export const signupInModalStyle = css`
  .responsive-dimensions {
    min-height: 22.5em;
  }
`;
